var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isReady ? _c('div', {
    staticClass: "content",
    attrs: {
      "data-test": "bio-material-view"
    }
  }, [!_vm.hideTitle ? _c('h2', [_vm._v("\n    " + _vm._s(_vm.materialTypeLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.getPopulatedDisplayFields, function (displayField) {
    var _vm$fieldData;
    return [displayField.name === 'field_biomat_plasmid_vector_type' ? _c('BioPlasmid', {
      key: displayField.name
    }, _vm._l(_vm.plasmidDisplay, function (plasmidField, index) {
      return _c('FieldDisplay', {
        key: plasmidField ? plasmidField.name : 'plasmid-field-' + index,
        attrs: {
          "display-field": plasmidField,
          "hide-empty": true,
          "individual-field-data": _vm.plasmidFields && plasmidField ? _vm.plasmidFields[plasmidField.name] : {}
        }
      });
    }), 1) : _c('FieldDisplay', {
      key: displayField === null || displayField === void 0 ? void 0 : displayField.name,
      attrs: {
        "display-field": displayField,
        "individual-field-data": (_vm$fieldData = _vm.fieldData) === null || _vm$fieldData === void 0 ? void 0 : _vm$fieldData[displayField === null || displayField === void 0 ? void 0 : displayField.name],
        "show-library-style": _vm.showLibraryStyle
      }
    })];
  }), _vm._v(" "), _c('div', {
    staticClass: "content-buttons"
  }, [_vm.canAddToLibrary ? _c('button', {
    staticClass: "secondary",
    attrs: {
      "data-test": "addtolibrary"
    },
    on: {
      "click": _vm.addToLibrary
    }
  }, [_vm._v("\n      Add to Library\n    ")]) : _vm._e(), _vm._v(" "), _vm.showAddToLibrary ? _c('b-button', {
    attrs: {
      "data-test": "goBack",
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments);
      }
    }
  }, [_vm._v("\n      Go Back\n    ")]) : _vm._e()], 1)], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }